import { DateRangeOption } from '../schema/DateRangeOption';
import { assertNever } from 'owa-assert';
import { OwaDate } from 'owa-datetime';
import endOfDay from 'owa-datetime/lib/owaDate/endOfDay';
import startOfMonth from 'owa-datetime/lib/owaDate/startOfMonth';
import startOfWeek from 'owa-datetime/lib/owaDate/startOfWeek';
import subDays from 'owa-datetime/lib/owaDate/subDays';
import subWeeks from 'owa-datetime/lib/owaDate/subWeeks';
import now from 'owa-datetime/lib/userDate/now';
import DateRange from 'owa-range-datepicker/lib/store/schema/DateRange';
import { getUserConfiguration } from 'owa-session-store';

export function getDateRangeForOption(dateRangeOption: DateRangeOption): DateRange | null {
    const date = now();

    switch (dateRangeOption) {
        case DateRangeOption.Month:
            return { startDate: startOfMonth(date), endDate: date };
        case DateRangeOption.Week:
            return { startDate: getStartOfWeek(date), endDate: date };
        case DateRangeOption.CustomDateRange:
            return null;
        case DateRangeOption.LastWeek:
            return {
                startDate: getStartOfLastWeek(date),
                endDate: getEndOfLastWeek(date),
            };
        default:
            return assertNever(dateRangeOption);
    }
}

function getStartOfWeek(date: OwaDate) {
    const userStartOfWeek = getUserConfiguration().UserOptions.WeekStartDay;
    return startOfWeek(date, userStartOfWeek);
}

function getStartOfLastWeek(date: OwaDate) {
    return subWeeks(getStartOfWeek(date), 1);
}

function getEndOfLastWeek(date: OwaDate) {
    return endOfDay(subDays(getStartOfWeek(date), 1));
}
